import { render } from "./PartnerCommunityView.vue?vue&type=template&id=28391850&scoped=true"
import script from "./PartnerCommunityView.vue?vue&type=script&lang=js"
export * from "./PartnerCommunityView.vue?vue&type=script&lang=js"

import "./PartnerCommunityView.vue?vue&type=style&index=0&id=28391850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28391850"]])

export default __exports__